export default __webpack_public_path__ + "static/media/Ravensilk Vest.a007c02a.jpg";